<template>
	<Container>
		<template v-for='modular in modulars'>
			<div class="carousel" v-if='modular.Code == "WSHome001"'>
				<Carousel v-model="value1" loop autoplay :autoplay-speed='8000' dots='none'>
			        <CarouselItem v-for='item in modular.items'>
			            <a :href='configUrl(item)' class="carousel-item">
							<img class="img" :src="item.Pic">
						</a>
			        </CarouselItem>
			    </Carousel>
			    <div class="indicator">
			    	<div class="dots">
				    	<div class="dot" @mouseenter='value1=i - 1' :class='{active:i - 1==value1}' v-for='i in modular.items.length'></div>
				    </div>
			    </div>
			</div>
			<div class="advertisement" v-else-if='modular.Code == "WSHome002"'>
				<div class="item zoom-out" v-for='item in modular.items'>
					<img v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
					<div class="bottom">
						<p class="title">{{item.Title}}</p>
						<p class="content" v-html='item.SubTitle'></p>
						<a :href='configUrl(item)' class="button"><span>{{item.Flag2}}</span></a>
					</div>
				</div>
			</div>
			<div class="l-advertisement" v-else-if='modular.Code == "WSHome003"'>
				<template v-for='item in modular.items'>
					<div class="bgc-box" v-if='item.Flag1 == 1'>
						<img v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
						<div class="desc">
							<p class="title" v-html='item.Title'></p>
							<p class="content" v-html='item.SubTitle'></p>
							<a :href="configUrl(item)" class="button button-primary">{{item.Flag2}}</a>
						</div>
					</div>
					<div class="front-box" v-else>
						<img v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
						<div class="right-box">
							<p class="title">{{item.Title}}</p>
							<p class="content">{{item.SubTitle}}</p>
							<a :href='configUrl(item)' class="more-url">{{item.Flag2 || '查看更多'}}</a>
						</div>
					</div>
				</template>
			</div>
			<div class="products" v-else-if='modular.Code == "WSHome004"' v-lazyFunc='initProduct'>
				<div class="head">
					<div class="title">品質甄選</div>
					<a v-if='modular.MoreUrl' :href='modular.MoreUrl' class="more">查看更多>></a>
				</div>
				<Scroller class='scroller' :unitWidth='270'>
					<ul>
						<template v-for='item in modular.items'>
							<ProductCell :ref='item.Code' :noWidth='isIE' :goodsWidth='goodsWidth' :isRead='true' :product='getProduct(item)' :key="item.Code" />
						</template>
					</ul>
				</Scroller>
			</div>
			<div class="news" v-else-if='modular.Code == "TabBar"'>
				<div class="head">
					<template v-for='(item,index) in modular.items'>
						<div  class="button title" :class='showTabIndex == index ? "button-primary":"normal"' @click='showTabIndex = index'>{{item.Name}}</div>
						<a v-if='showTabIndex == index && item.MoreUrl' :href='item.MoreUrl' class="more">查看更多>></a>
					</template>
				</div>
				<div class="items" v-for='(item,index) in modular.items' v-if='index == showTabIndex'>
					<template v-if='item.MediaType == "article"'>
						<div class="item" v-for='(article,index1) in item.items'>
							<p class="title">{{article.Title}}</p>
							<p class="datetime">{{article.ValidFrom | dateFormat}}</p>
							<!-- <p class="content">{{article.SubTitle | noHTML}}</p> -->
							<a :href='configUrl(article)' class="button-primary detail">{{article.Flag2 || '查看詳情'}}</a>
						</div>
					</template>
					<div class="video-container" v-else>
						<div class="items">
							<template v-for='(item,index) in item.items'>
								<a :href='configUrl(item)' class="item l-item" v-if='item.Flag1 == 1'>
									<img class="cover" v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
									<img class="play" src="@/assets/play.png">
									<p class="desc">{{item.Title}}</p>
								</a>
								<a :href='configUrl(item)' v-else class="item s-item" :key='index+"item"'>
									<div class="zoom-out">
										<img class="cover" v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
										<img class="play" src="@/assets/play.png">
										<p class="desc">{{item.Title}}</p>
									</div>
								</a>
							</template>
						</div>
					</div>
						
					</div>
					
				</div>
			</div>
			<template class="news" v-else-if='modular.Code == "WSHome007"'>
				<Assistant v-for='item in modular.items' :Code='item.KeyCode' class="assistant"></Assistant>
			</template>
		</template>
	</Container>
</template>

<script>
	import Scroller from '@/components/common/Scroller'
	import Assistant from '@/components/common/Assistant'
	import ProductCell from '@/components/order/ProductCell'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				value1:0,
				modulars:[],
				showTabIndex:0,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			Scroller,
			Assistant,
			ProductCell,
		},
		computed: {
			...mapState({
				productInfo: state => state.order.productInfo,
			}),
			products(){
				if (this.productInfo?.value?.length) {
					let products = this.productInfo.value.map(item=>item.products).flatMap(item=>item)
					return products
				}
				return []
			},
			goodsWidth(){
				if (document.body.clientWidth <= 768) {
					return 45
				}
				return 18
			},
			isIE() { //ie?
			     if (!!window.ActiveXObject || "ActiveXObject" in window){ 
			     	return true; 
			     } else{ 
			     	return false; 
			     }
			 }
		},
		methods: {
			...mapActions([
				'getPageConfigAction',
				'getPageConfigDetailAction',
				'initProductAction',
			]),
			async initData(){
				let modulars = await this.getPageConfigAction('WSHome')
				let response1 = await this.getPageConfigDetailAction({page:'WSHome'})
				let special = {
					Code:'TabBar',
					items:[],
				}
				modulars = modulars.filter(modular=>{
					let items = response1.filter(item=>item.Module == modular.Code)
					modular.items = items
					if (modular.ShowType == '050') {
						special.items.push(modular)
						return false
					}
					return true
				});
				this.modulars = [...modulars,special]
			},
			getProduct(item){
				let sku = item.KeyCode
				if (this.products.length) {
					let product = this.products.filter(item1=>item1.sku == sku)
					return product[0]
				}
				return {}
				
			},
			async initProduct() {
				await this.initProductAction();
				for (let key of Object.keys(this.$refs)) {
					this.$refs[key][0].reload()
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.service,.assistant {
		position: fixed;
		bottom: 100px;
	}
	.assistant {
		right:0;
	}
	.advertisement {
		display: flex;
		margin: auto;
		justify-content: space-between;
		margin-top: 0.2rem;
		width: 79.17vw;
		flex-wrap: wrap;
		.item {
			height:23.44vw;
			width: 38.54vw;
			position: relative;
			overflow: hidden;
			margin-top: 0.4rem;
			img {
				width: 100%;
				height:100%;
				object-fit: cover;
			}
			.bottom {
				position: absolute;
				bottom: 0.3rem;
				width:100%;
				text-align: center;
				.title {
					@include fontSize($font-size-24);
					font-weight: bold;
					color:white;
					text-align: center;
				}
				.button {
					margin: auto;
					margin-top: 20px;
					@include fontSize($font-size-20);
					border: 3px solid white;
					border-radius: 40px;
					padding: 3px 3.13vw;
					font-weight: bold;
					color:white;
					width:  13.54vw;
					min-width: 160px;
				}
				.button:hover {
					background-color: white;
					color:black;
					border-color: $theme-color;
				}
			}
		}
	}
	.l-advertisement {
		height:53.65vw;
		margin-top: 0.2rem;
		display:flex;
		position: relative;
		align-items: flex-end;
		.bgc-box {
			width:100%;
			position: absolute;
			top:0;
			z-index: 0;
			// display:none;
			img {
				display:block;
				width: 100%;
				height:53.65vw;
				object-fit: cover;
			}
			.desc {
				// position: absolute;
				top:10vw;
				max-width: 80vw;
				left: 5vw;
				color:white;
				.title {
					@include fontSize($font-size-24);
					font-weight: bold;
					margin-bottom: 0.2rem;
				}
				.content {
					@include fontSize($font-size-20);
				}
				.button {
					@include fontSize($font-size-24);
					position: absolute;
					left: 20%;
				    top: 47%;
				    width: 2.2rem;
				    height: 0.5rem;
					line-height: 0.5rem;
					background-color: $green;
					border-radius: 0.5rem;
					&:hover {
						background-color:$dark-green;
					}
				}
			}
		}
		.front-box {
			z-index: 9;
			flex:1;
			display:flex;
			margin: 0 0.3rem;
			margin-bottom: 0.4rem;
			border:1px solid #eee;
			box-shadow: 3px 3px 5px 1px rgba(0,0,0,.2);
			height:14vw;
			img {
				display:block;
				width: 18.23vw;
				height:100%;
				object-fit: cover;
				border-right: 1px solid #eee;
			}
			.right-box {
				flex:1;
				background-color: #fff;
				position: relative;
				padding: 0.1rem 0.2rem 0.1rem 0.1rem;
				.title {
					font-weight: bold;
					margin-bottom: 0.1rem;
				}
				.content {
					display: -webkit-box;
  					word-break: break-all;
					-webkit-line-clamp: 4;//嚮顯示多少行就給多大值
					-webkit-box-orient: vertical; 
					overflow: hidden;
				}
				.more-url {
					margin-top: 0.2rem;
					// position: absolute;
					display:block;
					color:$green;
					font-weight: bold;
				}
			}
		}
		
	}
	.products {
		// max-width: 1560px;
		.title {
			background-color: $theme-color;
		}
		margin: 0 5vw;
		margin-top: 0.4rem;
		.scroller {
			margin-top: 20px;
			ul {
            	list-style: none;
            	display: flex;
            	height:4.50rem;
			}
		}
		
	}
	.news {
		margin: auto;
		// max-width: 1560px;
		margin: 0 10vw;
		margin-top: 0.4rem;

		.item {
			margin:0 0.2rem;
			margin-bottom: 0.4rem;
			border-bottom: 1px solid #eee;
			.title {
				color:$theme-color;
				@include fontSize($font-size-18);
				margin-bottom: 5px;
			}
			.datetime,.content {
				margin-bottom: 5px;
			}
			.datetime {
				// max-width: 100px;
			}
			.detail {
				display: inline-block;
				padding: 3px 10px;
				border-radius: 20px;
				margin-top: 0.2rem;
				margin-bottom: 0.2rem;
			}
		}
	}
	.head {
		position: relative;
		text-align: center;
		margin-bottom: 20px;
		display:flex;
		justify-content: center;
		align-items: center;
		.title {
			color:white; 
			padding: 3px 0.4rem;
			border-radius: 40px;
			@include fontSize($font-size-24);
			font-weight: bold;
			display: inline-block;
			text-align: center;
		}
		.normal {
			background-color:white;
			color:black;
			border:1px solid #eee;
		}
		.more {
			position: absolute;
			right: 0;
		}
	}
	.video-container {
		display:flex;
		flex-wrap: wrap;
		.items {
			display: flex;
			flex-wrap: wrap;
			.item {
				border-bottom: none;
				position: relative;
				overflow: hidden;
				div {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
				.cover {
					width:100%;
					height:100%;
					object-fit: cover;
				}
				.play {
					position:absolute;
					width:2.6vw;
					height:2.6vw;
					left:calc(50% - 1.3vw);
					top:calc(50% - 1.3vw);
				}
				.desc {
					left: 0;
					background-color: rgba(0,0,0,0.3);
					color:#fff;
					position:absolute;
					bottom: 0;
					width:100%;
					text-align: center;
					font-weight: bold;
					line-height: 30px;
					display: -webkit-box;
  					word-break: break-all;
					-webkit-line-clamp: 1;//嚮顯示多少行就給多大值
					-webkit-box-orient: vertical; 
					overflow: hidden;
				}
				
			}
			.l-item {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 79.17vw;
				height:34.9vw;
				border-radius: 20px;
				margin-top: 2.6vw;
				.play {
					position:absolute;
					width:5vw;
					height:5vw;
				}
			}
			.s-item {
				// height:10vw;
				// width:16vw;
				flex:1;
				// min-width: 200px;
				// min-height: 128px;
				margin-top: 1.56vw;
				div {
					border-radius: 10px;
					overflow: hidden;
					position: relative;
					// margin: 0 1.56vw;
				}
				
			}
		}
	}
	@media (max-width: 768px){
		.advertisement {
			width: 95%;
			.item {
				width: 48%;
				height:30vw;
			}
		}
		.l-advertisement {
			.bgc-box {
				.desc {
					.button {
						width:4rem;
						height:1rem;
					}
				}
			}
			.front-box {
				height:18vw;
				.right-box {
					@include fontSize($font-size-12);
					.title {
						display: -webkit-box;
						word-break: break-all;
						-webkit-line-clamp: 2;//嚮顯示多少行就給多大值
						-webkit-box-orient: vertical; 
						overflow: hidden;
					}
					.content {
						display:none;
					}
				}
			}
		}
		.products {
			margin:0.4rem 2.5%;
			.scroller {
				margin-top: 20px;
				ul {
	            	height:270px;
				}
			}
		}
		.news {
			width: 95%;
			margin: 0.4rem 2.5%;
		}
		.video-container {
			.items {
				.item {
					.play {
						width: 40px;
						height:40px;
						left:calc(50% - 20px);
						top:calc(50% - 20px);
					}
				}
				.l-item {
					width: 95vw;
					height:50vw;
				}
				.s-item {
					width: 45vw;
					flex:auto;
					@include fontSize($font-size-12);
				}
			}
		}
	}
</style>